
import {useSearchParams} from "react-router-dom"
import { Box, Button, Card, Checkbox, Radio, RadioGroup,  Flex, Grid, HStack, Select, SimpleGrid, Spacer, Stack, Text, } from "@chakra-ui/react"
import { Link } from "react-router-dom"
import React, { useState, useEffect,  } from "react"
import CardProduct from "./CardPage"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { getCartData } from "../Redux/CartReducer/cartAction"
import { sideBar } from "../components/SideBar"
import { getProducts } from "../Redux/ProductReducer/productAction"
// import { useContext } from 'react'
// import {Authcontext} from "../Context/AuthContext"


const baseurl = "https://anthro-backen.onrender.com/dresses"


const getData =async(baseurl)=>{
   
        return await axios.get("https://anthro-backen.onrender.com/dresses")  
}


function Dresses() {

    const cart = JSON.parse(localStorage.getItem("cart"))
    // console.log(cart)

    const productData = useSelector((store) => store.productReducer.products)
    const cartData = useSelector((store) => store.cartReducer.cart) || []

    const [value, setValue] = useState("")
    console.log("onChange value", value)
   
    const [page, setPage] = useState(1)
    const [data, setData] = useState([])
    const [totalPages, setTotalPages] = useState(1)
    const [sortPrice, setSortPrice] = useState("")
  

    const dispatch = useDispatch()

    // const {cartData,setCartData}=useContext(Authcontext)

    const handelClick = (a, b) => {
        console.log("q")
        let filterData = data.filter((ele, ind) => {
            if (ele.price > a && ele.price < b) {
                return true
            } else if (a < ele.price) {
                return true
            }
        })
        console.log(filterData)
        setData(filterData)
    }





    useEffect(() => {

        dispatch(getProducts(baseurl))
        
    }, [page, sortPrice,])

    console.log(cartData)

    return (
        <Box w={"100%"} m={"auto"}  >
            <Box m={"auto"} w={"95%"} >


                <Box mt={5} bg="red.10">
                    <Flex alignItems={"center"} justifyContent={"space-evenly"} justifyItems={"center"} padding={5} >

                        <Button m={2} left={0} padding={8} bg="red.50"><Link>WEDDING GUEST DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link> CAUSAL DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link> PARTY DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link>WORK DRESSES</Link></Button>
                        <Button m={2} padding={8} bg="red.50"><Link> VACTION DRESSES</Link></Button>
                        <Button padding={8} bg="red.50"><Link > FROMAL DRESSES</Link></Button>
                    </Flex>
                    <hr></hr>
                </Box>

                <Box w={"100%"}>
                    <SimpleGrid display={"flex"}>
                        <Box w={"21%"} bg={"orange.50"}>
                            <Stack mb={3}>
                                <Text> Browse By:</Text>
                                <hr></hr>

                                <Box>
                                    <RadioGroup onChange={setValue} value={value}>
                                        <Stack >
                                            <Radio value='1' border={"1px solid grey"}>Cocktail & Party Dresses</Radio>
                                            <Radio value='2' >Lounge & Casual Dresses</Radio>
                                            <Radio value='3'>Maxi Dresses</Radio>
                                            <Radio value='4'>Maxi Dresses</Radio>
                                            <Radio value='6'>Mini & Tunic Dresses</Radio>
                                            <Radio value='5' >Jumpsuits</Radio>
                                        </Stack>
                                    </RadioGroup>
                                </Box>


                                <br></br>
                                <Text>Filter By:</Text>

                                <RadioGroup onChange={setValue} value={value}>
                                    <Stack>
                                    <Radio value='asc' border={"1px solid grey"}>Ascending</Radio>
                                    <Radio value='desc' >Descending</Radio>
                                    </Stack>
                                    
                                </RadioGroup>

                                <Text>Price :</Text>
                                <hr></hr>
                                <Checkbox name="filter">$25-$50</Checkbox>
                                <Checkbox name="filter">$50-&100</Checkbox>
                                <Checkbox name="filter">$100-$150</Checkbox>
                                <Checkbox name="filter">$150-$200</Checkbox>
                                <Checkbox name="filter">More than $200</Checkbox>

                                <Text>Brand :</Text>
                                <hr></hr>
                                <Checkbox >Levis</Checkbox>
                                <Checkbox >Allen Solly</Checkbox>
                                <Checkbox >H&M</Checkbox>
                                <Checkbox >Nike</Checkbox>
                                <Checkbox >ADiDAs</Checkbox>

                            </Stack>

                        </Box>


                        <Spacer />
                        <Box w={"78%"} >

                            <HStack>
                                <Text>Dresses : {63}

                                </Text>
                                <Spacer />
                                <Select placeholder='Select option' w="200px" onChange={(e) => setSortPrice(e.target.value)}>
                                    <option value='asc'>Low-High</option>
                                    <option value='desc'>High-Low</option>
                                    <option value='option3'>A-Z</option>
                                </Select>

                                <HStack>
                                    <Button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</Button>
                                    <Text>{page} / {totalPages}</Text>
                                    <Button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</Button>
                                </HStack>

                            </HStack>

                            <Box >


                                <Grid templateColumns='repeat(3, 1fr)' gap={6}>

                                    {productData.map((ele, id) => {

                                        return (
                                            <CardProduct
                                                key={ele.id}
                                                {...ele}
                                                
                                            />
                                        )
                                    }
                                    )}

                                </Grid>


                            </Box>

                        </Box>

                    </SimpleGrid>
                </Box>





            </Box>
        </Box>
    )
}


export default Dresses